<script lang="ts" setup>
import type { ProductAttributeValueSlotDto } from '@repo/api/web/models'

const props = defineProps<{
  attribute: ProductAttributeValueSlotDto
}>()

const displayValue = computed(() => {
  const raw = props.attribute.values[0]?.value
  if (raw == null) return null
  const parsed = Number.parseFloat(raw)
  return Number.isNaN(parsed) ? raw : parsed
})
</script>

<template>
  <UiAttribute
    :label="props.attribute.metadata.displayName"
    :content="displayValue"
    :ui="{ label: 'text-muted text-sm' }"
  />
</template>
